<template>
  <ContentTemplate title="Delete Account" :container-size-small="true">
    <form>
      <div class="danger-zone-delete">
        <FormGroupSection
            v-if="accountIsLocalProvided"
            :form-element="passwordInput"
            v-model:input-value="form[passwordInput.input.name]"
            :validator="v$.form[passwordInput.input.name]"
        />
        <FormGroupSection
            :form-element="deleteInput"
            v-model:input-value="form[deleteInput.input.name]"
            :validator="v$.form[deleteInput.input.name]"
        />

        <div class="fp-form-group">
          <div class="row mb-3">
            <div class="col-4"></div>
            <div class="col-8">
              <div class="attention">
                <p><b>Warning:</b></p>
                <p>Entering the Danger Zone will permanently delete the account and workspace, including all personalized data. This action is irreversible.</p>
                <br>
                <p>The deletion includes: workspace and workspace permalink, account and profile details, company information, all members decoupled from the workspace, decoupling from other workspaces, integrations disconnected from third-party tools, and all projects and created content within the workspace.</p>
                <br>
                <p style="color: var(--text-dark);">User accounts of team members will not be affected. </p>
                <br/>
                <p>Proceed only if deletion of the account and workspace is fully intended, as this action cannot be undone.</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8 d-flex justify-content-end mt-2">
              <ButtonElement
                  class="btn--ms btn--danger"
                  @clickOnButton="openConfirmationPopup()">
                Delete My Account & Workspace
              </ButtonElement>
            </div>
          </div>
        </div>
      </div>

    </form>
  </ContentTemplate>

</template>
<script lang="ts">
import {defineComponent} from 'vue';

import {required} from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import {ButtonElement, ContentTemplate, FormGroupSection} from "@shared/components";
import {AccountNs, CommonNs, type PopupNs, UserNs} from "@shared/types";
import {useAccountStore} from "@domains/account/stores/account.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {mapStores} from "pinia";
import {useUserStore} from "@shared/stores/user.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'DangerZoneView',
  components: {
    ButtonElement,
    ContentTemplate,
    FormGroupSection,
  },
  computed: {
    ...mapStores(useAccountStore, useGeneralStore, useUserStore),
  },
  data() {
    return {
      accountIsLocalProvided: false,
      form: {} as { [key: string]: string },
      passwordInput: {} as CommonNs.InputFormGroup,
      deleteInput: {} as CommonNs.InputFormGroup,
    };
  },
  setup() {
    return {v$: useVuelidate()};
  },
  validations() {
    return {
      form: {
        currentPassword: this.userStore.getUserInfo.authProvider === UserNs.AuthProvider.LOCAL ? {required}:{},
        typeDelete: {required},
      },
    };
  },
  beforeMount(): void {
    this.accountIsLocalProvided = this.userStore.getUserInfo.authProvider === UserNs.AuthProvider.LOCAL;
    this.buildForm();
  },
  methods: {
    buildForm(): void {
      this.form = {
        currentPassword: '',
        typeDelete: '',
      };

      this.passwordInput = {
        label: 'Current Password',
        iconType: 'fal',
        icon: 'Lock',
        input: {
          name: 'currentPassword',
          type: 'password',
          placeholder: 'Current Password',
        },
      } as CommonNs.InputFormGroup;

      this.deleteInput = {
        label: 'Type DELETE',
        iconType: 'fal',
        icon: 'Keyboard',
        input: {
          name: 'typeDelete',
          type: 'text',
          placeholder: 'DELETE',
        },
      } as CommonNs.InputFormGroup;
    },

    deleteAccount() {
      const payload = {
        password: this.form.currentPassword,
        typeDelete: this.form.typeDelete,
      } as AccountNs.DeleteAccountRequest;

      this.accountStore.deleteAccount(payload).then(() => {
        toast.success('Delete account confirmation email sent. Check inbox');
      });
    },

    openConfirmationPopup(): void {
      this.v$.$touch();
      // @ts-ignore
      if (this.v$.form.$invalid) {
        return;
      }

      const payload = {
        content: {
          title: 'Delete Account',
          // subTitle: item,
          message: '<p>Confirm deletion of the <strong>account</strong>?</p> <p>Recovery will not be possible after deletion.</p>',
        },
        callback: {
          content: 'Delete',
          function: this.deleteAccount,
        },
      } as PopupNs.Popup;

      this.generalStore.showPopup(payload)
    },
  },
});
</script>

<style lang="scss" scoped>

hr {
  margin: var(--space-32) var(--space-0);
}

.danger-zone {
  margin-bottom: var(--space-16);
}

.fp-form-group {
  & .description {
    font-size: var(--fs-14);
    color: var(--text-neutral);
    margin: var(--space-0);

    p {
      font-size: var(--fs-12);
      color: var(--text-neutral);
      margin: var(--space-0);
    }
  }

  & .attention {
    font-size: var(--fs-12);
    color: var(--red-100);
    margin: var(--space-0);

    p {
      font-size: var(--fs-12);
      color: var(--red-100);
      margin: var(--space-0);
    }
  }
}
</style>
